import NewLocationRow from './NewLocationRow';

export default NewLocationRow;
